import { render, staticRenderFns } from "./SistemaControllerEdit.vue?vue&type=template&id=a5b9bcb0"
import script from "./SistemaControllerEdit.vue?vue&type=script&lang=js"
export * from "./SistemaControllerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports